"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractStateManager = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const inversify_1 = require("inversify");
const p_limit_1 = __importDefault(require("p-limit"));
const types_1 = require("@refinitiv-data/types");
(0, inversify_1.decorate)((0, inversify_1.injectable)(), eventemitter3_1.default);
let AbstractStateManager = class AbstractStateManager extends eventemitter3_1.default {
    constructor() {
        super(...arguments);
        this.stateEventsEmitter = this;
        this.internalChannel = new eventemitter3_1.default();
        this._state = types_1.State.Closed;
        this.limit = (0, p_limit_1.default)(1);
        this.pendingEvents = [];
    }
    get state() {
        return this._state;
    }
    get invalidStateMessage() {
        return types_1.ErrorMessages.INVALID_STATE_MESSAGE;
    }
    async open() {
        await this.limit(async () => {
            if (this.state === types_1.State.Opened) {
                return;
            }
            this.setState(types_1.State.Pending);
            try {
                await this.initialize();
                if (this.state === types_1.State.Pending) {
                    this.setState(types_1.State.Opened);
                }
            }
            catch (err) {
                await this.cleanUp().catch(() => void 0);
                this.setState(types_1.State.Closed);
                throw err;
            }
        });
        return this;
    }
    async close() {
        return this.limit(async () => {
            this.setState(types_1.State.Closed);
            await this.cleanUp();
        });
    }
    emit(event, ...args) {
        this.internalChannel.emit(event, ...args);
        if (event === types_1.StateEvent.StateChanged) {
            return super.emit(event, ...args);
        }
        if (this.state === types_1.State.Pending) {
            this.pendingEvents.push({ event, args });
            return true;
        }
        if (this.state === types_1.State.Closed) {
            return true;
        }
        return super.emit(event, ...args);
    }
    validateState() {
        if (this.state !== types_1.State.Opened) {
            throw new Error(this.invalidStateMessage);
        }
    }
    setState(state) {
        if (this.state === state) {
            return;
        }
        this._state = state;
        if (state === types_1.State.Closed) {
            this.flushPendingEvents();
        }
        this.stateEventsEmitter.emit(types_1.StateEvent.StateChanged, this, this.state);
        if (state === types_1.State.Opened) {
            this.flushPendingEvents();
        }
    }
    flushPendingEvents() {
        const events = this.pendingEvents;
        this.pendingEvents = [];
        events.forEach(({ event, args }) => super.emit(event, ...args));
    }
};
exports.AbstractStateManager = AbstractStateManager;
exports.AbstractStateManager = AbstractStateManager = __decorate([
    (0, inversify_1.injectable)()
], AbstractStateManager);
//# sourceMappingURL=data:application/json;base64,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